import React from 'react'
import { Button, Icon } from '~ui';

export default function AddHeaderClose() {
    return (
        <Button variant='ghost' onClick={()=>window.close()}>
            <Icon name='close' />
        </Button>
    )
}